<template>
    <div class="fzg-news-pc">
      <div class="fzg-banner">
        <fzg-menu/>
        <div class="sologan"></div>
      </div>

      <div class="value-point-pc">
        <div class="value-point">
          <img src="../../assets/img2/pc/join/value.jpg" alt="">
        </div>
      </div>

      <div class="fzg-join-us-partner">
        <div class="js-title">
          <img src="../../assets/img2/pc/join/title_partner.png" alt="">
        </div>
        <div class="join-us-center">
          <div class="swiper mySwiper swiper-initialized swiper-horizontal swiper-backface-hidden">
            <div class="swiper-wrapper" aria-live="polite" style="transition-duration: 0ms; transform: translate3d(0px, 0px, 0px);">
              <div class="swiper-slide" aria-label="1 / 9">
                <div class="slide-item"> 凡卓是个非常温暖、包容的大家庭，小伙伴们都一样年轻，充满热爱与激情。我们服务创业者，因此本身也有创业的心态，平台非常注重每一个人的成长，愿意给大家提供机会，我们始终坚持长期主义，相信专业、真诚与热爱会换来公平的回报，成就客户，同时也成就我们自己的职业生涯 </div>
              </div>
              <div class="swiper-slide" aria-label="2 / 9">
                <div class="slide-item"> 作为“小饭桌创投”基金团队的成员，我在凡卓集团内感受到了一个创投生态所带来的力量。通过与其他业务团队的紧密协作沟通，我可以更快更全面的获得投资所需的产业认知和市场信息，也可以让我自己的思考和认知得到充分打磨和传播，帮助到更多创业者，产生更大价值。</div>
              </div>
              <div class="swiper-slide" aria-label="3 / 9">
                <div class="slide-item"> 在公司6年半的时间里，公司在不断长大和变强，我也在跟着公司的节奏，不断接受新的挑战与成长。商业环境、战略、业务一直在不断的变化，尤其身处于日新月异的创投圈，但最感动我的是公司和CEO的初心始终未变。我们一直在做帮助创业者从平凡到卓越的服务，无论是早期的创业培训到后来的投融资、基金投资甚至是现在的产业区域落地等。不忘初心，共赴山海，坚持对创业者的热爱，坚持为他们做有价值的事情，利他的同时成就我们自己。</div>
              </div>
              <div class="swiper-slide" aria-label="4 / 9">
                <div class="slide-item"> 这里没有垫底的人，更没有浑水摸鱼的人。同事们都很靠谱，做事认真负责、有原则、有目标、有态度，是非常清楚自己想要什么的一群人。每个人都在尽自己所能做到最好，这种尽自己所能并不是被害怕竞争淘汰的恐惧所驱动的努力，而是由十足的信仰和责任驱动的自然的努力。没有人会push谁，但是大家都足够focus on自己的事情，不会挑别人的刺，不会以“ta是不是偷懒了”为假设前提去看待别人，不会拿同事作为比较。打心底认可公司和自己在做的事，因为非常真诚地欣赏、感激、敬仰彼此而不自觉透露出来的“忠诚”。</div>
              </div>
              <div class="swiper-slide" aria-label="5 / 9">
                <div class="slide-item"> All in 硬科技，All in科技中国。投资者结构发生了巨变——国资崛起，中国的资源配置，越来越多地收拢于国内最大的这个资源体系。在这个背景下，在Long China的前提下，如何应对资金端和资产端两端的巨大变化？如何建立和维护与产业巨头与地方政府的关系？宏观的巨变，是一定会与我们个人的职业发展紧密相连的。在凡卓的日子里，在我们与国内优秀的大型产业方（如欣旺达、保碧等）交流的过程中，在我们与国内前沿的专家（院士与其他清北等校教授）沟通的过程中，在我们和国内强力的投资者/资源统筹者合作中，我有了自己的答案。人的命运，当然要靠自己的奋斗，但更要考虑历史的行程。资本市场发展的方向，是我们早几年就已经看到、近年持续投入、目前布局领先市场的。与最懂行的人同行，不仅仅加速你我短期职场的发展——它更意味着，我们跟外部和内部这群“看得清、拎得清”的人建立了长期的联系，这是长期职业发展所必须的。凡卓集团是国内最早布局硬科技的股权投资服务集团之一，也是最早建立产业和地方政府联系的投资银行之一。我们踏踏实实、坚定前行，方向不同，终点必然不同。有志于躬身入局于中国股权市场大变革的业界精英们，请与我们同行，市场发展，时不我待；加入凡卓，舍我其谁！</div>
              </div>
            </div>

            <div class="swiper-pagination swiper-pagination-bullets swiper-pagination-horizontal" style="bottom: 20px;">
              <span class="swiper-pagination-bullet"></span>
            </div>
            <br><br>
          </div>

        </div>
      </div>

      <div class="fzg-value-wrap">

        <div v-if="false" class="value-title">
          <img src="../../assets/img2/pc/join/title_value.png" alt="">
        </div>

        <div class="value-content"></div>
      </div>

      <div class="fzg-join-us-position">
        <div class="join-title">
          <img  src="../../assets/img2/pc/join/title_join.png" alt="">
        </div>
        <div class="fzg-join-wrap">
          <div class="join-group">
            <div class="group-title">社会招聘</div>
            <div class="position-list">
              <a class="position-item"
                v-for="(item, index ) in coop_job_list"
                v-if="showAllCoop ? true : index < 9"
                :href="'/join/jd?id=' + item.id" target="blank">{{item.title}}</a>
            </div>
            <div v-if="!showAllCoop" class="more-position" @click="showAllCoop = !showAllCoop">更多岗位</div>
          </div>

          <div class="join-group">
            <div class="group-title">实习生招聘</div>
            <div class="position-list">
              <a class="position-item"
                v-for="(item,index) in intern_job_list"
                :href="'/join/jd?id=' + item.id"
                v-if="showAllIntern ? true : index < 3"
                target="blank">{{item.title}}</a>
            </div>
            <div v-if="!showAllIntern" class="more-position" @click="showAllIntern = !showAllIntern">更多岗位</div>

            <div class="join-mail"> 如果您有兴趣应聘，请投递简历到邮箱: hr@xfz.cn </div>
          </div>

        </div>
      </div>


    </div>
</template>

<script>

import util from '../../assets/js/util'
import FzgMenu from '../common/FzgMenu.vue'

export default{
    components:{
      FzgMenu
    },
    props:[''],
    data(){
      return {
        activeCompany: 1,
        all_job_list: [],
        coop_job_list: [],
        intern_job_list: [],
        showAllCoop: false,
        showAllIntern: false,
      }
    },
    methods:{
      gotoJD(item) {
        console.log(item)
        this.$router.push({path: '/join/jd', query: {id: item}, history: false})
      },
      getJobList() {
        var self = this
        util.resource({
            url: '/api/fzg/job_list/',
            method: 'get',
            success (res) {
              if (res.code == 200) {
                self.all_industry_data_list = res.data.list

                self.coop_job_list = self.all_industry_data_list.filter(item => item.type == 'coop') // 社会
                self.intern_job_list = self.all_industry_data_list.filter(item => item.type == 'intern') // 实习生
              }
            }
        })
      },
      initSwiper() {
        var swiper = new Swiper(".mySwiper", {
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            // disableOnInteraction: true,
            pauseOnMouseEnter: true,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable :true,
          },
        });
      },
    },
    mounted(){
      this.getJobList()
      var self = this
      $(function() {
        self.initSwiper()
      })
    },
    watch: {
      'fzTeamList': function() {
      },
    },

}
</script>

<style lang="scss" scoped>
.fzg-news-pc {
  .fzg-banner {
    // border: 1px solid red;
    // background: url(../../assets/img2/pc/join/banner.jpg) no-repeat;
    // background: url(https://static-image.xfz.cn/1686266460749/join-bn.png) no-repeat;
    background: url(https://static-image.xfz.cn/1687734811921/join_banner.png) no-repeat;
    background-color: #8799b1;
    height: 340px;
    position: relative;
    background-size: auto;
    background-position: center;
    .sologan {
      width: 100%;
      height: 45px;
      background-image: url(../../assets/img2/pc/join/sologan.png);
      background-repeat: no-repeat;
      background-size: auto 100%;
      background-position: center;
      margin: 80px auto 0;
    }
  }

  .value-point-pc {
    // border: 1px solid red;
    display: block;
    margin: 100px auto 80px;
    position: relative;
    height: 450px;
    .value-point {
      width: 100%;
      height: 400px;
      text-align: center;
      img {
        // border: 1px solid #ccc;
        width: 1050px;
        margin: 0 auto;
        margin-left: 20px;
      }
    }
  }

  .fzg-join-us-partner {
    overflow: auto;
    display: block;
    background: url(../../assets/img2/pc/join/js_bg.jpg) no-repeat;
    // background-color: #e6e6e6;
    background-size: 100% 100%;
    background-position: center;
    width: 100%;
    height: 620px;
    position: relative;
    .js-title {
      // border:  1px solid #ce262f;
      width: 160px;
      margin: 70px auto 0;
      img {
        width: 140px;
      }
    }
    .join-us-center {
      // border: 1px solid #ccc;
      width: 1100px;
      height: 370px;
      margin: 50px auto 0;
      background: url(https://static-image.xfz.cn/1686392030556/join-partner-bg.png) no-repeat;
      background-size: 100%;
      color: white;
      // padding: 120px 60px 0;
      line-height: 1.8;
      font-size: 16px;
        .swiper {
          // border: 1px solid blue;
          // background: gray;
          // width: 900px;
          height: 370px;
          width: 100%;
          height: 100%；
        }

        .swiper-slide {
          font-size: 18px;
          // background: #ededed;
          display: flex;
          justify-content: center;
          align-items: center;
          .slide-item {
            // border: 1px solid white;
            justify-content: center;
            align-items: center;
            text-align: justify;
            overflow: auto;
            padding: 20px 40px;
            line-height: 1.6;
          }
        }

    }


  }

  .fzg-value-wrap {
    // border: 1px solid red;
    background: #f8f9fe;
    height: 320px;
    .value-title {
      // border:  1px solid #ce262f;
      // width: 160px;
      margin: 60px auto 0;
      text-align: center;
      img {
        width: 220px;
      }
    }
    .value-content {
      background: url(../../assets/img2/pc/join/long_bg.png) no-repeat;
      background-size: auto 100%;
      background-position-x: center;
      background-position-y: -40px;
      width: 100%;
      height: 360px;
      position: relative;
      // margin-bottom: 100px;
    }
  }

  .fzg-join-us-position{
    // border: 1px solid red;
    overflow: auto;
    margin: 0 auto;
    position: relative;
    background: #f8f9fe;
    .join-title {
      // border:  1px solid #ce262f;
      width: 100%;
      margin: 60px auto 0px;
      text-align: center;
      img {
        width: 150px;
      }
    }
    .fzg-join-wrap {
      // border: 1px solid #ccc;
      overflow: auto;
      width: 1100px;
      // height: 600px;
      text-align: left;
      color: #575758;
      margin: 0 auto 80px;
      font-size: 16px;

      .join-group {
        margin-top: 40px;
        .group-title {
          // border: 1px solid red;
          font-size: 22px;
          text-align: center;
          font-weight: bold;
          margin: 0 auto 20px;
          padding: 10px;
        }
        .position-list {
          text-align: center;
          .position-item {
            // border: 1px solid #ccc;
            vertical-align: top;
            cursor: pointer;
            width: 320px;
            min-height: 110px;
            margin: 15px;
            display: inline-block;
            background: white;
            padding: 20px 25px;
            color: #444444;
            text-align: left;
            font-size: 19px;
          }
        }
        .more-position {
          width: 180px;
          margin: 40px auto 60px;
          text-align: center;
          padding: 6px 30px;
          border-radius: 20px;
          background: white;
          border: 1px solid #ababab;
          cursor: pointer;
        }
        .join-mail {
          text-align: center;
          color: #c28e4f;
          font-size: 18px;
        }
      }
    }
  }


}
</style>



// WEBPACK FOOTER //
// FzgJoinPc.vue?42fca5d4